import { createFileRoute } from '@tanstack/react-router';
import { ProjectsView } from '../components/features/project/index.js';

/** 全体PJ看板の URL search params。エンジニア看板の健康度診断カードから team ビューへ deep-link する用途。 */
interface AllPjBoardSearch {
  /** 初期選択するチームタブ（TEAM_OPTIONS の key）。未指定 / 不正値は '全体' */
  team?: string;
}

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 全体PJ看板ページ（旧 /projects 一覧本体の移設先）。ProjectsView をログインユーザー所属に応じたスコープ（PI Div=全社 / 横断 PMO=自 Div）で描画する薄いルートラッパー。プロジェクト管理フォルダ配下のサブページ。search param `team` で初期チームタブを指定できる
 * @graph-connects ProjectsView [calls] プロジェクト一覧ビュー描画
 */
export const Route = createFileRoute('/projects/all-pj-board')({
  component: AllPjBoardPage,
  validateSearch: (search: Record<string, unknown>): AllPjBoardSearch => ({
    team: typeof search.team === 'string' ? search.team : undefined,
  }),
});

/** @graph-connects ProjectsView [calls] プロジェクト一覧ビュー描画 */
function AllPjBoardPage() {
  const { team } = Route.useSearch();
  return <ProjectsView pageKey="allPjBoard" initialTeam={team} />;
}
